// src/connects/chat-rooms-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import socketRsync from '../helpers/socket-rsync'
import filter from 'lodash/filter'
import map from 'lodash/map'

export const mapStateToProps = (state)=> {
  return {
    isFetching: state.chatRooms.isFetching,
    isFetchFailed: state.chatRooms.isFetchFailed,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    chatRooms: state.chatRooms.items,
    user: state.user.current,
    productTour: state.productTour.state,
    hasMore: state.chatRooms.hasMore,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const names = stateProps.chatRooms && map(stateProps.chatRooms, (room)=> {
    const thumbnail = room.members.length == 2 && filter(room.members, (member) => member.user_id != stateProps.user.user_id)[0].icon_image.thumb_url || undefined
    const icon =  room.members.length > 2 && "people" || undefined
    const members = filter(room.members, (member)=> member.user_id != stateProps.user.user_id)
                     .slice(0, 3).map((member)=> member.name).join(', ')
    const sequence = room.sequence_id ? ` (${room.sequence_id})` : ''
    return {
      name: room.name || (room.members.length > 4 ? members + '...' : members) + sequence,
      chat_room_id: room.chat_room_id,
      thumbnail: thumbnail,
      icon: icon,
      icon_image: room.icon_image,
      unread_count: room.unread_count,
    }
  })

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    chatRoomNames: names
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    openChatRoom: (chat_room_id)=> {
      dispatch(actions.openRightSidePage('chat_messages', {chat_room_id: chat_room_id}, true))
    },

    deleteChatRoom: (props, chatRoom)=> {
      dispatch(actions.deleteChatRoom(chatRoom.chat_room_id))
      dispatch(emitAlertMessage({ message: 'label:チャットルームを削除しました', name: chatRoom.name }, 'success'))
    },

    createChatRoom: (props)=> {
      dispatch(actions.createChatRoom(props.ui.users.map((member)=> member.user_id)))
    },

    fetchChatRooms: (props)=> {
      var offset = props.chatRooms && props.chatRooms.length || 0
      dispatch(actions.fetchChatRooms(offset))
    },

    willMount: (props)=> {
      (!props.productTour || props.productTour.chatRoom != 'hide') && dispatch(actions.hideProductTour('chatRoom'))
      dispatch(actions.fetchChatRooms(0))
      dispatch(actions.fetchChatRoomUnreadCount())
    },

    willUpdate: (props, nextProps)=> {
      if (props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }, true))
      }
    },

    receiveSocket: (message, message_type)=> {
      if (message_type == 'chat_room')
        /**
         * chat_roomを削除された場合／membersに自分自身が含まれていない場合は、ストアからchat_roomを削除するため、
         * パラメータに「true」を渡す
         */
        dispatch(actions.loadChatRoom(message.chat_room, (message.deleted || message.chat_room.obsoleted)))
      else if (message_type == 'chat' && message.appending)
        // チャットルームに新たな投稿があった場合、未読件数を取得する
        dispatch(actions.fetchChatRooms(0))
    },

    requestSync: ()=> dispatch(actions.fetchChatRooms(0)),
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  socketRsync('chat', 'chat_room'),
  context({ showUserSelectionDialog: PropTypes.func }),
  ui({ state: { users: undefined, }}),
  lifecycle,
  trackPage('chat_rooms'),
)



// WEBPACK FOOTER //
// ./src/connects/chat-rooms-page.js